import { Component, Signal } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgForOf, NgIf, NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';
import { ProgressService } from './service/progress.service';
import { Progress } from './models/interfaces/progress.interface';
import { DisabledDirective } from '../../directives/disabled/disabled.directive';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    imports: [
        IconComponent,
        NgIf,
        ReactiveFormsModule,
        ButtonComponent,
        NgForOf,
        NgStyle,
        DisabledDirective
    ]
})
export class ProgressComponent {

  constructor(
    private readonly progressService: ProgressService
  ) {}

  public progress: Signal<Progress[]> = this.progressService.progress;

  public open = true;

  public cancel(p: Progress): void {
    if (p.canceled || !p.cancel)
      return;

    p.canceled = true;
    p.cancel();
  }

}
